import mvtCardSchool from '@/common/components/mvtcardschool/mvt-cardschool.vue';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'dspNearbySchool',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp'])
    },
    components: {
        mvtShifter,
        mvtCardSchool
    }
};
